module.exports = __webpack_public_path__ + "fonts/deliver-ic.svg";